import Loader from '@/components/Loader.vue'
import ModifiedDot from '@/components/ModifiedDot.vue'

const formStatus = {
  data () {
    return {
      successSnackbar: false, // 是否顯示成功餅乾盒
      isSaving: false,
      isSaveFailed: false,
      error: null,
      dialog: false,
      valid: false,
      isModified: false,
    }
  },
  methods: {
    clearError () {
      this.isSaveFailed = false
      this.error = null
    },
    clearIsModified () {
      this.$nextTick(() => { this.isModified = false })
    },
    close () {
      this.dialog = false
      this.id = null
      this.isModified = false
    },
  },
  computed: {
    transition () {
      return this.isFullscreen ? 'dialog-bottom-transition' : 'dialog-transition'
    },
    isFullscreen () {
      return this.isMobile
    },
  },
  components: {
    Loader,
    ModifiedDot,
  },
  watch: {
    isModified (self) {
      if (self) {
        window.onbeforeunload = () => '有尚未發佈的變更，是否確認捨棄變更?'
      } else {
        window.onbeforeunload = null
      }
    },
  },
  // 在有未發佈內容時提示存檔
  beforeRouteLeave (to, from, next) {
    if (!this.isModified || window.confirm('有尚未發佈的變更，是否確認捨棄變更?')) {
      next()
    } else {
      next(false)
    }
  },
}

export { formStatus }
